export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0008s_0000_Black-&-White-23.b57123bd.png";